import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
};

// ---- Auth ----
export const apiLogin = async (email, password) =>
  (await api.post("/auth/login", { email, password })).data;
export const apiSendVerification = async (email, name) =>
  (await api.post("/auth/send-verification", { email, name })).data;
export const apiRegisterVerified = async (body) =>
  (await api.post("/auth/register-verified", body)).data;

// ---- Formules commerciales La BASE (Founder) ----
export const getFounderFormules = async () => (await api.get("/founder/formules")).data;
export const putFounderFormules = async (cfg) => (await api.put("/founder/formules", cfg)).data;
export const getPublicFormules = async () => (await api.get("/formules")).data;
export const getCartQuote = async (items, code) => (await api.post("/cart/quote", { items, code: code || null })).data;

// ---- Média catalogue (upload photo) ----
export const uploadMedia = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return { id: data.id, url: `${API_URL}${data.url}` };
};

// ---- Catalogue (Shopify) ----
export const fetchProducts = async () => (await api.get("/products")).data.products;
export const fetchCollections = async () => (await api.get("/collections")).data.collections;
export const fetchCollectionProducts = async (handle) =>
  (await api.get(`/collections/${handle}/products`)).data.products;

// ---- Univers de marque (catalogue CLIENT branché sur les cubes La BASE Maison) ----
export const getUniverse = async (key) => (await api.get(`/universe/${key}`)).data;
export const getMaisonHome = async () => (await api.get(`/maison/home`)).data;

// ---- Commandes standard ----
export const createOrder = async (orderData) => (await api.post("/orders", orderData)).data;
export const fetchOrders = async () => (await api.get("/orders")).data;
export const fetchOrder = async (orderId) => (await api.get(`/orders/${orderId}`)).data;

// ---- Devis livraison au km ----
export const getDeliveryQuote = async (payload) =>
  (await api.post("/delivery-quote", payload)).data;

// ---- Suivi client (livraison standard) ----
export const getClientTrack = async (token) => (await api.get(`/track/${token}`)).data;

// ---- Tyluss concierge + Voice Layer ----
export const tylussConcierge = async (message, candidates = null) =>
  (await api.post("/tyluss/concierge", { message, candidates })).data;
export const tylussConciergeDecide = async (session_id, authorize, accept_alternative = false) =>
  (await api.post("/tyluss/concierge/decide", { session_id, authorize, accept_alternative })).data;
export const voiceInteract = async (transcript, candidates = null) =>
  (await api.post("/tyluss/voice/interact", { transcript, candidates }, { timeout: 60000 })).data;
// ---- Mode FLUIDE : propositions instantanées (0 LLM) + message Gemini court ----
export const tylussInstant = async (message, order_time = null) =>
  (await api.post("/tyluss/instant", { message, order_time })).data;
export const tylussGeminiReply = async (message, proposals, order_time = null) =>
  (await api.post("/tyluss/gemini/reply", { message, proposals, order_time }, { timeout: 45000 })).data;
// Analyse sémantique COMPLÈTE par Gemini (toute la galaxie La BASE) → propositions + réponse.
export const tylussGeminiConverse = async (message, order_time = null) =>
  (await api.post("/tyluss/gemini/converse", { message, order_time }, { timeout: 60000 })).data;
export const getVoiceProfile = async () => (await api.get("/tyluss/voice/profile")).data;
export const updateVoiceProfile = async (patch) =>
  (await api.put("/tyluss/voice/profile", patch)).data;
export const voiceProfileNL = async (text) =>
  (await api.post("/tyluss/voice/profile/nl", { text })).data;
export const getVoiceProviders = async () => (await api.get("/tyluss/voice/providers")).data;
export const getTylussState = async () => (await api.get("/tyluss/state")).data;
export const selectVoiceEngines = async (capabilities) =>
  (await api.post("/tyluss/voice/select-engines", capabilities)).data;

// ---- Tyluss : anticipation + panier fluide (catalogue réel → VORTEX) ----
export const tylussAnticipation = async () =>
  (await api.get("/tyluss/anticipation")).data;
export const tylussBasketSdui = async (items) =>
  (await api.post("/tyluss/basket/sdui", { items })).data;
export const tylussBasketFulfill = async (payload) =>
  (await api.post("/tyluss/basket/fulfill", payload, { timeout: 120000 })).data;

// ---- Restaurants partenaires (catalogue dynamique — même backend que le mobile) ----
export const getPublicRestaurants = async (base) =>
  (await api.get("/restaurants", { params: base ? { base } : {} })).data.restaurants;
export const getRestaurantMenu = async (restaurantId) =>
  (await api.get(`/restaurants/${restaurantId}/menu`)).data;
export const partnerGetRestaurant = async () => (await api.get("/partner/restaurant")).data;
export const partnerGetCatalogs = async () => (await api.get("/partner/restaurant/catalogs")).data;
export const partnerGetMenu = async (restaurantId = null) =>
  (await api.get("/partner/restaurant/menu", { params: restaurantId ? { restaurant_id: restaurantId } : {} })).data;
export const partnerCreateCategory = async (name, kind = null, restaurantId = null) =>
  (await api.post("/partner/restaurant/categories", { name, kind }, { params: restaurantId ? { restaurant_id: restaurantId } : {} })).data;
export const partnerUpdateCategory = async (categoryId, patch) =>
  (await api.put(`/partner/restaurant/categories/${categoryId}`, patch)).data;
export const partnerReorderCategories = async (orderedIds, restaurantId = null) =>
  (await api.post("/partner/restaurant/categories/reorder", { ordered_ids: orderedIds }, { params: restaurantId ? { restaurant_id: restaurantId } : {} })).data;
export const partnerReorderItems = async (categoryId, orderedIds) =>
  (await api.post(`/partner/restaurant/categories/${categoryId}/items/reorder`, { ordered_ids: orderedIds })).data;
export const partnerSetItemCategories = async (itemId, categoryIds) =>
  (await api.put(`/partner/restaurant/items/${itemId}/categories`, { category_ids: categoryIds })).data;

// ---- Livraison colis/courrier (univers Soins & Services) ----
export const getCourierSettings = async () => (await api.get("/courier/settings")).data;
export const getCourierSettingsPublic = async () => (await api.get("/courier/settings/public")).data;
export const updateCourierSettings = async (patch) => (await api.put("/courier/settings", patch)).data;
export const listCourierApplications = async (status) => (await api.get("/courier/applications", { params: status ? { status } : {} })).data;
export const setCourierApplicationStatus = async (id, status, reason) => (await api.post(`/courier/applications/${id}/status`, { status, reason })).data;
export const courierApply = async (body) => (await api.post("/courier/apply", body)).data;
export const getMyCourier = async () => (await api.get("/courier/me")).data;
export const quoteParcel = async (body) => (await api.post("/parcels/quote", body)).data;
export const parcelDistance = async (body) => (await api.post("/parcels/distance", body)).data;
export const createParcel = async (body) => (await api.post("/parcels", body)).data;
export const myParcels = async () => (await api.get("/parcels/mine")).data;
export const openParcels = async () => (await api.get("/parcels/open")).data;
export const getParcelById = async (id) => (await api.get(`/parcels/${id}`)).data;
export const makeParcelOffer = async (id, priceChf) => (await api.post(`/parcels/${id}/offer`, { price_chf: priceChf })).data;
export const listParcelOffers = async (id) => (await api.get(`/parcels/${id}/offers`)).data;
export const acceptParcelOffer = async (id, offerId) => (await api.post(`/parcels/${id}/offers/${offerId}/accept`)).data;
export const payParcel = async (id) => (await api.post(`/parcels/${id}/pay`)).data;
export const confirmParcelDelivery = async (id) => (await api.post(`/parcels/${id}/confirm`)).data;
export const parcelShowcase = async () => (await api.get("/parcels/showcase")).data;
export const getPrefaceFrame = async (token) => (await api.get("/tyluss/frame", { params: token ? { token } : {} })).data;
export const getPrefaceContent = async () => (await api.get("/preface/content")).data;
export const updatePrefaceContent = async (payload) => (await api.put("/preface/content", payload)).data;
export const partnerDeleteCategory = async (categoryId) =>
  (await api.delete(`/partner/restaurant/categories/${categoryId}`)).data;
export const partnerDeleteItem = async (itemId) =>
  (await api.delete(`/partner/restaurant/items/${itemId}`)).data;
export const partnerCreateItem = async (payload) =>
  (await api.post("/partner/restaurant/items", payload)).data;
export const partnerUpdateItem = async (itemId, patch) =>
  (await api.put(`/partner/restaurant/items/${itemId}`, patch)).data;
export const partnerSetStock = async (itemId, body) =>
  (await api.patch(`/partner/restaurant/items/${itemId}/stock`, body)).data;

// ---- Onboarding partenaire (demande publique → approbation Founder) ----
export const partnerApply = async (payload) =>
  (await api.post("/partner/apply", payload)).data;
export const partnerAccountMe = async () => (await api.get("/partner/account/me")).data;
export const partnerChangePassword = async (current_password, new_password) =>
  (await api.post("/partner/account/change-password", { current_password, new_password })).data;

// ---- Founder : gestion des partenaires ----
export const founderListApplications = async (status) =>
  (await api.get("/admin/partner/applications", { params: status ? { status } : {} })).data.applications;
export const founderApproveApplication = async (appId, payload) =>
  (await api.post(`/admin/partner/applications/${appId}/approve`, payload)).data;
export const founderRejectApplication = async (appId, reason) =>
  (await api.post(`/admin/partner/applications/${appId}/reject`, { reason })).data;
export const founderListRestaurants = async () =>
  (await api.get("/admin/restaurants")).data.restaurants;
export const founderUpdateRestaurant = async (restaurantId, patch) =>
  (await api.put(`/admin/restaurants/${restaurantId}`, patch)).data;
export const founderSuspendAccount = async (userId) =>
  (await api.post(`/admin/partner/account/${userId}/suspend`, {})).data;
export const founderReactivateAccount = async (userId) =>
  (await api.post(`/admin/partner/account/${userId}/reactivate`, {})).data;
export const founderDeletePartner = async (restaurantId) =>
  (await api.delete(`/admin/restaurants/${restaurantId}`)).data;

// ---- Founder : candidatures livreurs (Flotte VORTEX) ----
export const founderListDriverApplications = async (status) =>
  (await api.get("/vortex/admin/driver-applications", { params: status ? { status } : {} })).data;
export const founderApproveDriverApp = async (appId, vehicleType) =>
  (await api.post(`/vortex/admin/driver-applications/${appId}/approve`, vehicleType ? { vehicle_type: vehicleType } : {})).data;
export const founderRejectDriverApp = async (appId, note) =>
  (await api.post(`/vortex/admin/driver-applications/${appId}/reject`, { note: note || "" })).data;

// ---- Founder : analyse & rendement (TULUSS insights) ----
export const apiInsights = async (windowDays = 7) =>
  (await api.get("/tuluss/insights", { params: { window_days: windowDays } })).data;

export const apiOptimizations = async () =>
  (await api.get("/tuluss/optimizations")).data;

// ---- Founder : supervision partenaires (cockpit unique) ----
export const founderOpsOverview = async () =>
  (await api.get("/founder/ops/overview")).data;
export const founderStockMovements = async (restaurantId = null, limit = 300) =>
  (await api.get("/founder/ops/stock-movements", { params: { ...(restaurantId ? { restaurant_id: restaurantId } : {}), limit } })).data;
export const founderBaseSplit = async () =>
  (await api.get("/founder/finance/base-split")).data;

// ---- Commande de livraison (partagée) ----
export const createDeliveryOrder = async (orderData) =>
  (await api.post("/delivery-orders", orderData)).data;

// ---- Favoris client (couche minimale, scopée utilisateur) ----
export const fetchFavorites = async () => (await api.get("/favorites")).data;
export const addFavorite = async (productId, title) =>
  (await api.post("/favorites", { product_id: productId, title })).data;
export const removeFavorite = async (productId) =>
  (await api.post("/favorites/remove", { product_id: productId })).data;

// ---- Santé & Services à domicile (MÊMES API que l'App — home_services.py) ----
export const hsTrades = async () => (await api.get("/home-services/trades")).data.trades;
export const hsSearch = async (trade, commune, sort) =>
  (await api.get("/home-services/search", { params: { trade, commune, sort } })).data.pros;
export const hsProDetail = async (proId) =>
  (await api.get(`/home-services/pros/${proId}`)).data.profile;
export const hsSlots = async (proId, date) =>
  (await api.get(`/home-services/pros/${proId}/slots`, { params: { date } })).data.slots;
export const hsBook = async (payload) =>
  (await api.post("/home-services/bookings", payload)).data;
export const hsMyBookings = async () =>
  (await api.get("/home-services/me/bookings")).data.bookings;
export const hsCancelBooking = async (id) =>
  (await api.post(`/home-services/bookings/${id}/cancel`, {})).data;
export const hsReviews = async (proId) =>
  (await api.get(`/home-services/pros/${proId}/reviews`)).data;
